import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconPinMap';
/** Renders an SVG icon. */
const SvgPinMap = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M11.501 15.95a1 1 0 1 1 0 2h-2.01a1 1 0 0 0-.958.714l-1.806 6.05A1 1 0 0 0 7.686 26h16.63a1 1 0 0 0 .959-1.286l-1.806-6.05a1 1 0 0 0-.958-.714h-2.01a1 1 0 0 1 0-2h2.01a3 3 0 0 1 2.875 2.143l1.805 6.05A3 3 0 0 1 24.317 28H7.686a3 3 0 0 1-2.875-3.858l1.805-6.05a3 3 0 0 1 2.875-2.142z"
      />
      <path
        fill="currentColor"
        d="M21 10.8c0-1.589-.577-2.762-1.445-3.547-.826-.747-1.976-1.195-3.29-1.248L16 6c-1.424 0-2.673.456-3.554 1.253C11.578 8.038 11 9.21 11 10.8c0 1.958 1.106 4.298 2.463 6.379A31 31 0 0 0 16 20.522a31 31 0 0 0 2.537-3.343C19.894 15.098 21 12.758 21 10.799Zm2 0c0 2.575-1.394 5.335-2.787 7.471-1.416 2.173-2.962 3.892-3.506 4.436a1 1 0 0 1-1.414 0c-.543-.544-2.089-2.263-3.506-4.436C10.394 16.136 9 13.375 9 10.8c0-2.115.789-3.841 2.104-5.03C12.406 4.592 14.157 4 16 4l.345.007c1.716.07 3.331.659 4.552 1.763C22.212 6.959 23 8.685 23 10.8"
      />
      <path fill="currentColor" d="M17 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
    </svg>
  );
};
SvgPinMap.displayName = displayName;
export default SvgPinMap;
